import React from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

import { UIButton } from "../../../components/ui";
import Input from "../../../components/Input";
import messages from "../../../assets/locale/messages";
import { forgetPasswordRequest } from "../../../store/Auth/actions";

import "./ForgetPassword.scss";

const ForgetPassword = () => {
  const lang = useSelector((state) => state.locale.lang);
  const dispatch = useDispatch();
  const { forgetPassword } = messages[lang];
  const history = useHistory();
  const PreviousIcon = lang === "ar" ? ArrowRight : ArrowLeft;
  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    setFieldValue,
    dirty,
    isValid,
    setFieldTouched,
  } = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("validEmailFormat").required("emailRequired"),
    }),
    onSubmit: ({ email }) => {
      dispatch(forgetPasswordRequest({ email }));
    },
  });

  const handleEmailChange = (value) => {
    setFieldTouched("email");
    setFieldValue("email", value.trim());
  };

  return (
    <div className="auth-form-shell forget-password-page w-100">
      <header className="auth-form-shell__header forget-password-page__header">
        <h1 className="auth-layout__card__title">{forgetPassword.title}</h1>
        <p className="auth-layout__card__subtitle">{forgetPassword.subtitle}</p>
      </header>

      <form
        className="auth-form-shell__form forget-password-page__form"
        onSubmit={handleSubmit}
        noValidate
      >
        <div className="forget-password-page__field">
          <Input
            id="email"
            name="email"
            type="email"
            label={forgetPassword.labels.email}
            placeholder={forgetPassword.placeholders.email}
            required
            value={values.email}
            onChange={handleEmailChange}
            onBlur={handleBlur}
            isInputHasErr={Boolean(touched.email && errors.email)}
            errMsg={errors.email}
            fullWidth
          />
        </div>

        <div className="auth-layout__actions">
          <UIButton
            type="button"
            variant="outline"
            size="large"
            className="auth-layout__btn--back"
            startIcon={<PreviousIcon size={20} aria-hidden />}
            onClick={() => history.goBack()}
          >
            {forgetPassword.previous}
          </UIButton>
          <UIButton
            type="submit"
            variant="primary"
            size="large"
            className="auth-layout__btn--primary"
            disabled={!(dirty && isValid)}
          >
            {forgetPassword.actionBTN}
          </UIButton>
        </div>
      </form>
    </div>
  );
};

export default ForgetPassword;
